@if (getShow()) {
<div class="d-flex justify-content-center" [ngStyle]="{'padding-top':(isModeMobile)?'70%':'20%'}" style="/*background-color: black; opacity: 0.2;*/position: absolute;height: 100%;width: 100%;
top: 0;
left: 0; bottom: 0; z-index: 99;">
    <!-- <mat-spinner></mat-spinner> -->
    <div>
      <img src="assets/images/loading/spinner_occidente.gif" width="100px" height="100px" style="z-index: 10000000;opacity:2 !important;" alt="" srcset="">
    </div>
  </div>
}

